import React from 'react';
import type { Testimonial } from '../types/testimonial';
import { PinIcon, QuoteIcon, StarIcon } from './icons/CraftIcons';
type CommunityMarqueeProps = {
  items: Testimonial[];
};
function MarqueeCard({
  item
}: {
  item: Testimonial;
}) {
  return <figure className="flex w-[300px] shrink-0 gap-3 rounded-2xl border border-hairline bg-ivory p-3 shadow-soft transition-transform duration-300 hover:-translate-y-1.5 sm:w-[340px]" data-id="element-43" data-mp="1kubuiyeygd8e">
      <div className="h-[104px] w-[88px] shrink-0 overflow-hidden rounded-xl border border-hairline bg-linen" data-id="element-44" data-mp="2dhpiw84l80gw">
        <img src={item.image} alt={item.imageAlt} className="h-full w-full object-cover" loading="lazy" decoding="async" data-id="element-45" data-mp="2ifhlpx6rt6zv" />
      </div>
      <div className="flex min-w-0 flex-col" data-id="element-46" data-mp="28g9ymia8hxzk">
        <span className="flex items-center gap-0.5 text-gold" data-id="element-47" data-mp="t1kz2q53isk7">
          {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-3 w-3 fill-current" strokeWidth={1.2} data-id="element-48" data-mp="x3fy1nzk0tut" />)}
          <span className="sr-only" data-id="element-49" data-mp="pq793p1mu6mq">5 out of 5 stars</span>
        </span>
        <p className="mt-1 text-[10px] font-extrabold uppercase tracking-wide text-gold-dark" data-id="element-50" data-mp="psjwwiu2nb7p">
          {item.highlight}
        </p>
        <blockquote className="relative mt-1 text-[11.5px] leading-snug text-ink-soft" data-id="element-51" data-mp="yrnhxscsu0ou">
          <QuoteIcon className="absolute -left-0.5 -top-1 h-4 w-4 text-hairline" data-id="element-52" data-mp="upacz65vm6t4" />
          <span className="relative pl-4" data-id="element-53" data-mp="18pl3g839xjdr">{item.quote}</span>
        </blockquote>
        <figcaption className="mt-2 flex flex-wrap items-center gap-x-2 text-[10.5px]" data-id="element-54" data-mp="18n8evc30garq">
          <span className="font-extrabold text-ink" data-id="element-55" data-mp="13odyegsimyas">{item.name}</span>
          <span className="flex items-center gap-1 text-ink-faint" data-id="element-56" data-mp="1ie32ajrztger">
            <PinIcon className="h-3 w-3" data-id="element-57" data-mp="1dfrsg91p75wj" />
            {item.meta}
          </span>
        </figcaption>
      </div>
    </figure>;
}
export function CommunityMarquee({
  items
}: CommunityMarqueeProps) {
  return <div className="group relative overflow-hidden" data-id="element-58" data-mp="1mhrbf6w9wk24">
      {/* edge fades */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-0 z-10 w-12 bg-gradient-to-r from-cream to-transparent" data-id="element-59" data-mp="k3ts5z44hbqy" />
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 right-0 z-10 w-12 bg-gradient-to-l from-cream to-transparent" data-id="element-60" data-mp="p0k5ieojlt8o" />

      <ul className="gpu flex w-max animate-marquee gap-4 py-2 group-hover:[animation-play-state:paused]" data-id="element-61" data-mp="xw03n7wbyuk2">
        {[...items, ...items].map((item, index) => <li key={`${item.id}-${index}`} aria-hidden={index >= items.length} data-id="element-62" data-mp="17sw5iurq4ifn" data-mpi={index}>
            <MarqueeCard item={item} data-id="element-63" data-mp="17uz7md65i20q" />
          </li>)}
      </ul>
    </div>;
}